import { IconQuestionCircleOutlined } from "@suse-o11y/icons";
import { Tooltip, TooltipBoundary, TooltipTrigger } from "@suse-o11y/tooltip";
import React from "react";

import { Switch, type SwitchProps } from "../switch/Switch";

export interface LabeledSwitchProps extends SwitchProps {
	label: string;
	id?: string;
	help?: string;
}

export const LabeledSwitch: React.FC<LabeledSwitchProps> = ({
	label,
	id = label.replaceAll(" ", "_"),
	help,
	...restProps
}) => (
	<div className="flex items-center justify-between">
		<label className="flex cursor-pointer items-center text-grey-800" htmlFor={id}>
			{label}
			{help && (
				<TooltipBoundary>
					<TooltipTrigger aria-label="More information" className="button button-sm button-square ml-1">
						<IconQuestionCircleOutlined className="text-core-icon-neutral-tertiary" />
					</TooltipTrigger>

					<Tooltip className="tooltip/tooltip">{help}</Tooltip>
				</TooltipBoundary>
			)}
		</label>

		<Switch id={id} {...restProps} />
	</div>
);
